import { type FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppRoute } from '@common/app/routes';
import { useCountDownTimer } from '@common/hooks/count-down-timer';
import { type ActiveBoostItemProps } from '@common/types/components';
import { useModal } from '@context/ModalContext';
import { clearWorkshopBoost } from '@redux/reducers/workshopReducer';
import { selectWorkshopByNameOrId } from '@redux/selectors/workshopSelectors';
import { useAppDispatch, useAppSelector } from '@redux/store';

import { ActiveBoostItem } from '../ActiveBoostItem';

const WorkshopActiveBoostItem: FC<ActiveBoostItemProps> = ({
  id,
  expiresInSeconds,
  plantId,
  boostType,
  effectMultiplier,
}) => {
  const dispatch = useAppDispatch();
  const workshop = useAppSelector((state) =>
    selectWorkshopByNameOrId(state, id),
  );
  const seconds = useCountDownTimer(expiresInSeconds);
  const navigate = useNavigate();
  const { setIsGoodsBoostModalOpen } = useModal();

  useEffect(() => {
    if (seconds === 0 && seconds !== expiresInSeconds) {
      dispatch(clearWorkshopBoost({ plantId, boostType }));
    }
  }, [expiresInSeconds, seconds]);

  const onClick = (): void => {
    navigate(AppRoute.WORKSHOP + `/${id}`);
    setIsGoodsBoostModalOpen(false);
  };

  if (!workshop || !expiresInSeconds) {
    return null;
  }

  return (
    <div onClick={onClick}>
      <ActiveBoostItem
        seconds={seconds}
        itemName={workshop.name}
        effectMultiplier={effectMultiplier}
      />
    </div>
  );
};

export { WorkshopActiveBoostItem };
